import { render, staticRenderFns } from "./DesignView.vue?vue&type=template&id=1c104067&scoped=true&"
import script from "./DesignView.vue?vue&type=script&lang=js&"
export * from "./DesignView.vue?vue&type=script&lang=js&"
import style0 from "./DesignView.vue?vue&type=style&index=0&id=1c104067&prod&scoped=true&lang=css&"
import style1 from "./DesignView.vue?vue&type=style&index=1&id=1c104067&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c104067",
  null
  
)

export default component.exports